import React, { useState, useContext, useEffect } from 'react';

import PageContext from '../Context/PageContext';
import { SaveTemplate } from '../Util/SaveUtil';
import localforage from 'localforage';

const SaveButton = () => {

    const { selectedItem, setSelectedItem,
        objItems, setObjItems,
        mapListPoint, setMapListPoint, addMapListPoint,
        mapListTrace, setMapListTrace,
        addMapSource, addMapLayer, traceStyle, traceLayout, addMapListTrace,
        pageSize, setPageSize,
        pageColor, setPageColor,
        mapPosition, setMapPosition,
        mapIndex, setMapIndex,
        mapTaille, setMapTaille,
        mapUrlStyle, setMapUrlStyle,
        majDate, setMajDate,
        modeAdmin, elevationData,
        isMode3D, page,
        jsonFormat, isPortrait, setIsPortrait, mapLock } = useContext(PageContext);


    const [isTxtMajVisible, setIsTxtMajVisible] = useState(false);

    useEffect(() => {
        /* Call only is majDate is not empty, and if value changes with useeffect param*/
        if (majDate != '') {
            setIsTxtMajVisible(true);

            const timer = setTimeout(() => {
                setIsTxtMajVisible(false);
            }, 2000);

            return () => clearTimeout(timer);
        }
    }, [majDate]);


    function saveLocalStorage() {

        var exportJSON = SaveTemplate({ mapListPoint, objItems, pageSize, pageColor, mapPosition, mapIndex, mapTaille, mapUrlStyle, mapListTrace, elevationData, isMode3D, isPortrait, mapLock, jsonFormat })

        //window.localStorage.setItem('affiche_map_context', JSON.stringify(exportJSON));
        // The same code with localForage:
        localforage.setItem('affiche_map_context', JSON.stringify(exportJSON));

        //var lastMajDate = new Date().toLocaleDateString('fr-FR', { year: "numeric", month: "numeric", day: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" }).replace(',', '');
        var lastMajDate = new Date().toLocaleTimeString('fr-FR', { hour: "2-digit", minute: "2-digit", second: "2-digit" }).replace(',', '');

        if (setMajDate != null) setMajDate(lastMajDate)
    }

    return (
        <div className="save-btn-container">
            <div>
                <button className="main-button save-button" onClick={saveLocalStorage} title="Sauvegarder dans le navigateur"><img className="icone-button-main" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/diskette.svg"}></img></button>
            </div>
            <div className="save-text-cont">
                {/**/isTxtMajVisible &&
                    <div className="save-text">
                        <img className="save-text-img" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/save-2.svg"}></img>
                        <div className="hidden-text">
                            {majDate}
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default SaveButton;